module.exports = __webpack_public_path__ + "static/media/dots3.1a0b6574.png";